"use client";

import { startTransition } from "react";

/**
 * Time-based reassurance, not progress. Real seekers get their kundali in about
 * 3 seconds (submit→kundali_result_viewed, human cohort, 28d to 2026-10-05:
 * p50 3.0–3.3s, p90 5–7s, under 1% over 20s); the 12s / 28s steps reassure the
 * rare slow chart. None of these messages claims that an engine stage has
 * completed before the response arrives.
 */
export const LOADING_STATUS_MESSAGES = [
  {
    en: "Preparing your chart. This usually takes a few seconds.",
    hi: "आपकी कुंडली तैयार हो रही है। इसमें आम तौर पर कुछ ही सेकंड लगते हैं।",
  },
  {
    en: "Calculating your planetary chart. Please keep this page open.",
    hi: "आपके ग्रहों की गणना हो रही है। कृपया यह पेज खुला रखें।",
  },
  {
    en: "Still working through the details. Some charts take a little longer.",
    hi: "विवरण पर काम अभी जारी है। कुछ कुंडलियों में थोड़ा और समय लगता है।",
  },
] as const;

/** @internal */
export const LOADING_STATUS_DELAYS_MS = [12_000, 28_000] as const;

export function loadingStatusTimers(setStatus: (status: number) => void) {
  return LOADING_STATUS_DELAYS_MS.map((delay, index) =>
    setTimeout(() => startTransition(() => setStatus(index + 1)), delay)
  );
}
